import styled from 'styled-components';

import Header from './components/Header';

const ChildrenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  position: relative;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const StaticLayout = ({ children, showHeader }) => {
  return (
    <Container>
      {showHeader && <Header />}
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Container>
  );
};

export default StaticLayout;
